/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRegimenInvestigation from './treatment-regimen-investigation';
import TreatmentRegimenInvestigationDetail from './treatment-regimen-investigation-detail';
import TreatmentRegimenInvestigationUpdate from './treatment-regimen-investigation-update';
import TreatmentRegimenInvestigationDeleteDialog from './treatment-regimen-investigation-delete-dialog';

const TreatmentRegimenInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRegimenInvestigation />} />
    <Route path="new" element={<TreatmentRegimenInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRegimenInvestigationDetail />} />
      <Route path="edit" element={<TreatmentRegimenInvestigationUpdate />} />
      <Route path="delete" element={<TreatmentRegimenInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRegimenInvestigationRoutes;
